<template>
  <div class="father" style="">
    <div class="dyh-line-group">
      <div class="dyh-line-group-label">店 铺 权 限</div>
      <el-input style="margin-left: 20px;" size="small" type="text" v-model="basciInfo.searchPermission"
        @change="searchMerchantPermission" placeholder="请输入权限名或权限id进行查询"></el-input>
    </div>
    <div class="dyh-body-group" v-if="basciInfo.wtytbshow">
      <wty-table ref="wtyTableRef" :who="'mchPermission'" :operate="'权 限 修 改'" :wtycolumnList="basciInfo.wtycolumnList"
        :wtytbheigh="500" :wtytbList="wtytbList" @wtyTbreturn="wtyTbreturn"></wty-table>
    </div>
    <el-dialog title="权限信息修改" :visible.sync="basciInfo.showdialog" width="500px" style="margin-top: 0px" top="15vh"
      center>
      <div style="display: flex">
        <el-form label-width="150px" style="min-width: 350px; margin-right: 20px">
          <el-form-item label="权限id：">
            <el-input :disabled="true" v-model="permissionData.permission_id"></el-input>
          </el-form-item>
          <el-form-item label="权限名称：">
            <el-input placeholder="请输入权限名称：" v-model="permissionData.permission_name"></el-input>
          </el-form-item>
          <el-form-item label="权限类别：">
            <el-select v-model="permissionData.classify_id" placeholder="请选择">
              <el-option style="width: 500px;" v-for="item in basciInfo.classifyList" :key="item.classify_id"
                :label="item.classify_name" :value="item.classify_id">
                <div style="display: flex;flex-direction: column;">
                  <div>
                    <span style="float: left; color: #67C23A;">{{ item.classify_id }}</span>
                    <span style="float: left; margin-left: 5px;">{{ item.classify_name }}</span>

                    <span style="float: right;font-size: 16px;">{{ item.remark }}</span>
                  </div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="权限介绍：">
            <el-input placeholder="请输入权限名称：" v-model="permissionData.description"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSureClick">确 定</el-button>
        <el-button @click="basciInfo.showdialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import wtyTable from "@/components/wty-table";
//eslint-disable-next-line
import { mListPermission, mListClassify } from '@/api/merchant.js';
import { mUpdatePermission } from "@/api/service.js";
import { sortJSONByKeys } from "@/js/public.js";
export default {
  components: { wtyTable },
  data() {
    return {
      basciInfo: {
        showdialog: false,
        wtytbshow: true,
        searchPermission: "",
        wtycolumnList: [{
          prop: "permission_id",
          align: "center",
          label: "权限id",
          fixed: "left"
        }, {
          prop: "permission_name",
          align: "center",
          label: "权限名",
          fixed: "left"
        }, {
          prop: "classify_id",
          align: "center",
          label: "权限分类",
          fixed: "left"
        }, {
          prop: "description",
          align: "center",
          label: "权限简介",
          fixed: "left"
        }],
        classifyList: []
      },
      wtytbList: [],
      permissionData: {}
    }
  },
  mounted() {
    this.getPermissionList();
    this.getClassifyList();
  },
  methods: {
    async dialogSureClick() {
      const res = await mUpdatePermission(this.permissionData);
      console.log("返回值：", res);
      if (res.state === true) {
        this.successMessage(res.message);
      }
    },
    /**
     * 模糊搜索店铺权限
     */
    searchMerchantPermission() {
      this.$refs.wtyTableRef.wtyTableIn(this.basciInfo.searchPermission);
      console.log(this.basciInfo.searchPermission);
    },
    /**
     * wty-table组件返回内容
     * @param {object} e 返回内容
     */
    wtyTbreturn(bd) {
      console.log("eeeeeeeeeeeeeee", bd);
      this.basciInfo.showdialog = true;
      this.permissionData = bd;
    },
    /**
     * 获取所有类别列表
     */
    async getClassifyList() {
      this.basciInfo.classifyList = await mListClassify();
    },
    /**
     * 获取所有权限列表
     */
    async getPermissionList() {
      this.basciInfo.wtytbshow = false;
      const permissionList = await mListPermission();
      //console.log(JSON.stringify(list));
      const result = sortJSONByKeys(Object.groupBy(permissionList, (item) => item.classify_id.slice(0, 2)));
      //console.log("result======================", JSON.stringify(result));

      let list = [];
      for (let key in result) {
        let lk = result[key].sort((a, b) => {
          return a.classify_id - b.classify_id;
        })
        list.push(...lk);
      }
      this.wtytbList = [];
      list.forEach((item, index) => {
        this.wtytbList.push({ ...item, classify_id: item.classify_id.trim().padEnd(6, "0") });
      })
      /* this.wtytbList = list.map(item => {
        const classifyId = item?.classify_id;
        if (classifyId == null) return "000000";
        return String(classifyId).padEnd(6, "0");
      }); */
      this.basciInfo.wtytbshow = true;
    }
  }
}
</script>
<style lang="less" scoped>
.father {
  display: flex;
  padding: 10px;
  flex-direction: column;
}
</style>